import React from "react";
import PropTypes from "prop-types";

import FormInput from "components/FormInput";
import FormInDialog from "components/FormInDialog";
import ClientNameInput from "screens/Clients/components/ClientNameInput";

import clientFormValidation from "screens/Clients/components/clientFormValidation";

const ClientModal = ({
  OpenerComponent,
  title,
  submitActionText,
  cancelActionText,
  isEdit = false,
  ...formProps
}) => {

  const generateCodeFromName = (name) => {
    if (!name) return "";
    
    const cleanName = name.replace(/[^A-Za-z0-9]/g, "");
    
    return cleanName.substring(0, 4).toUpperCase();
  };

  const clientModalFields = [
    {
      name: "name",
      component: ClientNameInput,
      props: {
        label: "Name *",
        placeholder: "Client name",
        fullWidth: true,
        variant: "outlined",
        isEdit: isEdit,
        generateCodeFromName: generateCodeFromName,
      },
    },
    {
      name: "code",
      component: FormInput,
      props: {
        label: "Code *",
        placeholder: "Client code (1-4 characters)",
        fullWidth: true,
        variant: "outlined",
        inputProps: { maxLength: 4, style: { textTransform: 'uppercase' } },
        disabled: isEdit,
      },
      onChange: (value, form) => {
        form.setFieldValue("codeManuallyEdited", true);
        form.setFieldValue("code", value.toUpperCase());
      },
    },
    {
      name: "address",
      component: FormInput,
      props: {
        label: "Address",
        placeholder: "Physical address",
        fullWidth: true,
        variant: "outlined",
        multiline: true,
        rows: 2,
      },
    },
    {
      name: "email",
      component: FormInput,
      props: {
        label: "Email",
        placeholder: "contact@example.com",
        fullWidth: true,
        variant: "outlined",
        type: "email",
      },
    },
    {
      name: "color",
      component: FormInput,
      props: {
        label: "Color",
        placeholder: "#1976D2",
        fullWidth: true,
        variant: "outlined",
        type: "color",
      },
    },
    {
      name: "contactPersonName",
      component: FormInput,
      props: {
        label: "Contact Person Name",
        placeholder: "Contact person name",
        fullWidth: true,
        variant: "outlined",
      },
    },
    {
      name: "contactPersonPhone",
      component: FormInput,
      props: {
        label: "Contact Person Phone",
        placeholder: "+1234567890",
        fullWidth: true,
        variant: "outlined",
      },
    },
    {
      name: "notes",
      component: FormInput,
      props: {
        label: "Notes",
        placeholder: "Additional notes about the client",
        fullWidth: true,
        variant: "outlined",
        multiline: true,
        rows: 4,
      },
    },
  ];

  return (
    <FormInDialog
      validate={clientFormValidation}
      formFields={clientModalFields}
      submitActionText={submitActionText}
      title={title}
      cancelActionText={cancelActionText}
      OpenerComponent={props => <OpenerComponent {...props} />}
      {...formProps}
    />
  );
};

ClientModal.propTypes = {
  OpenerComponent: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  submitActionText: PropTypes.string.isRequired,
  cancelActionText: PropTypes.string.isRequired,
  isEdit: PropTypes.bool,
};

export default ClientModal;

